export default function CTA() {
  return (
    <section className="bg-[#1B2A4A] py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-white text-2xl md:text-3xl font-extrabold mb-4">
          À votre tour ?
        </h2>
        <p className="text-white/80 text-base leading-relaxed mb-8">
          Rejoignez nos clients satisfaits. Demandez un diagnostic gratuit et un devis clair pour votre volet roulant.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
          <a
            href="tel:0374473240"
            className="inline-flex items-center justify-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appelez le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 bg-transparent border border-white text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-white/10 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Demander un devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}